import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WeatherIcon } from "./WeatherIcons";
import "./Header.css";

const LANGS = [
  { code: "sl", label: "Slovenian", img: "/Slike/slika2.png" }, // public/Slike
  { code: "en", label: "English",   img: "/Slike/slika3.png"    }, // public/Slike
];

function isDaytime() {
  const hour = new Date().getHours();
  return hour >= 7 && hour < 21;
}

export default function Header() {
  const { i18n } = useTranslation();
  const [open, setOpen]       = useState(false);
  const [weather, setWeather] = useState(null);
  const ref                   = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    fetch("https://api.open-meteo.com/v1/forecast?latitude=46.24&longitude=15.11&current_weather=true&temperature_unit=celsius")
      .then((r) => r.json())
      .then((data) => { if (data.current_weather) setWeather(data.current_weather); })
      .catch(() => {});
  }, []);

  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  return (
    <header className="header">
      <Link to="/" className="logo-link">
        <img
          src="/Slike/Rotary.png"
          alt="Rotary Club Žalec Logo"
          className="header-logo"
          loading="eager"
        />
      </Link>

      <div className="header-controls">
        <div className="header-weather">
          {weather ? (
            <>
              <WeatherIcon
                code={weather.weathercode}
                isDay={isDaytime()}
                size={24}
                className="weather-icon-gold"
              />
              <span className="weather-text-gold">
                {Math.round(weather.temperature)}°C Žalec
              </span>
            </>
          ) : "Loading…"}
        </div>

        {/* ZA ČLANE — matches language image height exactly */}
        <Link to="/Onas/Podstrani/Login" className="zaclanevpish hc__btn" aria-label="Za člane">
          <img src="/Slike/slika1.png" alt="ZA ČLANE" className="hc__img" loading="lazy" />
        </Link>

        {/* Language switcher */}
        <div className="rotary-lang-dropdown" ref={ref}>
          <button
            className="rotary-lang-btn hc__btn"
            onClick={() => setOpen((o) => !o)}
            aria-haspopup="listbox"
            aria-expanded={open}
            aria-label={`Language: ${current.label}`}
          >
            <img src={current.img} alt={current.label} className="hc__img" />
          </button>

          {open && (
            <ul className="rotary-lang-list" role="listbox">
              {LANGS.map((lang) => (
                <li
                  key={lang.code}
                  className={`rotary-lang-option${i18n.language === lang.code ? " selected" : ""}`}
                  onClick={() => { i18n.changeLanguage(lang.code); setOpen(false); }}
                  role="option"
                  aria-selected={i18n.language === lang.code}
                >
                  <img src={lang.img} alt={lang.label} className="hc__optimg" />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </header>
  );
}
